export * from '@primeuix/themes/material/scrollpanel';
export { default } from '@primeuix/themes/material/scrollpanel';
